import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

// PrimeNg
import { ProgressSpinnerModule } from 'primeng/progressspinner';

// Service
import { LoadingService } from './service/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  private loadingService = inject(LoadingService);
  isLoading = this.loadingService.isLoading;
}
